import suggestService from '@/apis/suggest/service';
import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import { Form, Select } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { SelectProps } from 'antd/lib';
import _ from 'lodash';
import * as React from 'react';

export interface IEmrSearchProps
  extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'>,
    Omit<SelectProps, 'name'> {
  searchConfig?: {
    key: string;
    field: string;
  };
}

const EmrSearch: React.FC<IEmrSearchProps> = ({
  className = '',
  searchConfig,
  name,
  field,
  onChange,
  disabled,
  labelProps = {},
  ...props
}) => {
  searchConfig = searchConfig || field?.extra?.search;
  const documentDb = searchConfig?.key;
  const [search, setSearch] = React.useState<string>('');
  const [newOptions, setNewOptions] = React.useState<DefaultOptionType[]>([]);
  const {
    data: res,
    fetchNextPage,
    isFetchingNextPage,
  } = suggestService.useGetSuggestInfinite({ key: documentDb, limit: 10, search: search });

  let options: DefaultOptionType[] = [];

  res?.pages?.forEach((d) => {
    options = [
      ...options,
      ...(d.data || [])?.map((o: any) => ({
        label: _.get(o, searchConfig?.field as string),
        value: o.id,
        raw: o.raw,
      })),
    ];
  });

  const debouncedSearch = _.debounce((keyword: string) => setSearch(keyword), 700);

  const form = Form.useFormInstance();

  const ref = React.useRef<HTMLElement | null>(null);

  return (
    <span
      ref={ref}
      onDoubleClick={() => {
        const values = form?.getFieldsValue();
        console.log(values);
      }}
    >
      <EmrFormItem
        field={field}
        name={name}
        getValueFromEvent={(val, option) => option}
        getValueProps={(val) => {
          return { value: val?.label || _.get(val, searchConfig?.field as string) };
        }}
        initialValue={disabled ? undefined : field?.default}
        {...labelProps}
      >
        <Select
          disabled={disabled}
          loading={isFetchingNextPage}
          className={'base-select w-full ' + className}
          {...props}
          onPopupScroll={(e: any) => {
            if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
              !isFetchingNextPage && fetchNextPage();
            }
          }}
          showSearch
          onChange={function (_v, o: any) {
            const id = (ref.current?.querySelector('input')?.id ?? '') as string;
            if (id && field?.extra.mapping?.length && form) {
              const name = id.split('_');
              const values = form?.getFieldsValue();
              field.extra.mapping.forEach((d) => {
                name[name.length - 1] = d?.link;
                _.set(values, name.join('.'), _.get(o, d?.field));
              });

              form.setFieldsValue(values);
            }
            onChange?.(_v, o);
          }}
          onSearch={debouncedSearch}
          options={[...options, ...newOptions]}
          filterOption={false}
          //   onKeyDown={(e: any) => {}}
          onKeyUp={(e: any) => {
            const value = e.target.value;
            const nOption = {
              label: value,
              value: value,
              raw: { _id: value },
            };
            _.set(nOption, searchConfig?.field as string, value);
            setNewOptions([nOption]);
            if (e.keyCode === 13 && value) {
              const name = e.target.id.split('_').join('.');
              const values = form?.getFieldsValue();
              _.set(values, name, value);
              form.setFieldsValue(values);
            }
          }}
        />
      </EmrFormItem>
    </span>
  );
};
export default EmrSearch;
